export default "__VITE_ASSET__VhAgOumN__"